import { menuTypeDict } from '@/dictionary/menu'
import { companyTypeDict } from '@/dictionary/company'
import {
  platformFunctionModuleDict,
  workbenchServiceDict
} from '@/dictionary/system'

// 子路由的引入
import PUBLIC_TENDER from '@/router/business/supplier/public-tender'
import PARTICIPATE_ROUTE from '@/router/business/supplier/participate'
import INVITATION_ROUTE from '@/router/business/supplier/invitation'
import COLLABORATE_ROUTE from '@/router/business/supplier/collaborate'

/**
 * 供应商投标报价路由
 */
export default {
  path: 'supplier',
  type: menuTypeDict.DIRECTORY.value,
  meta: {
    title: '投标报价',
    layout: 'DefaultLayout'
  },
  applicableCompanyTypes: [
    { companyType: companyTypeDict.ENTERPRISE.value },
    { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
    { companyType: companyTypeDict.SELF_EMPLOYEE.value },
    { companyType: companyTypeDict.PERSON.value }
  ],
  platformAlias: [],
  applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
  roles: [
    platformFunctionModuleDict.SUPPLIER.right,
    platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
  ],
  superviseInstitutions: [],

  children: [
    // 招标采购信息
    PUBLIC_TENDER,
    // 已参与项目
    PARTICIPATE_ROUTE,
    // 邀请函
    INVITATION_ROUTE,
    // 订单协同
    COLLABORATE_ROUTE,
    // 全网商机
    {
      path: 'https://biddog.yingcaicheng.com/network-notice',
      type: menuTypeDict.DIRECTORY.value,
      meta: {
        title: '全网商机',
        isExternal: true,
        icon: 'icon-side_business'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
        { companyType: companyTypeDict.SELF_EMPLOYEE.value },
        { companyType: companyTypeDict.PERSON.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 标讯订阅
    {
      path: 'https://biddog.yingcaicheng.com/subscription/list',
      type: menuTypeDict.DIRECTORY.value,
      meta: {
        title: '标讯订阅',
        isExternal: true,
        icon: 'icon-side_subscribe'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
        { companyType: companyTypeDict.SELF_EMPLOYEE.value },
        { companyType: companyTypeDict.PERSON.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 竞争对手分析
    {
      path: 'https://biddog.yingcaicheng.com/competitor-analysis/list',
      type: menuTypeDict.DIRECTORY.value,
      meta: {
        title: '竞争对手分析',
        isExternal: true,
        icon: 'icon-side_balance'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
        { companyType: companyTypeDict.SELF_EMPLOYEE.value },
        { companyType: companyTypeDict.PERSON.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 采购单位分析
    {
      path: 'https://biddog.yingcaicheng.com/purchaser-analysis/list',
      type: menuTypeDict.DIRECTORY.value,
      meta: {
        title: '采购单位分析',
        isExternal: true,
        icon: 'icon-side_supplier_lib'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
        { companyType: companyTypeDict.SELF_EMPLOYEE.value },
        { companyType: companyTypeDict.PERSON.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 数据定制导出
    {
      path: 'https://biddog.yingcaicheng.com/custom-data/filter',
      type: menuTypeDict.DIRECTORY.value,
      meta: {
        title: '数据定制导出',
        isExternal: true,
        icon: 'icon-side_export'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
        { companyType: companyTypeDict.SELF_EMPLOYEE.value },
        { companyType: companyTypeDict.PERSON.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    }
  ]
}
